/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Super_Such_Anteater_ClaspInputs */

const fr_super_such_anteater_clasp = /** @type {(inputs: Super_Such_Anteater_ClaspInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

/**

* @param {Super_Such_Anteater_ClaspInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const super_such_anteater_clasp = /** @type {((inputs?: Super_Such_Anteater_ClaspInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Super_Such_Anteater_ClaspInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_super_such_anteater_clasp(inputs)
});